import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

type Props = {
  question: string;
  /** True when this item is the currently-open one in its accordion group. */
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

/**
 * Single FAQ entry. Visual states (`.open`, chevron rotation, max-height
 * transition on `.faq-answer`) are all driven by the original CSS — we just
 * toggle the `.open` class via React state.
 */
export default function FaqItem({ question, open, onToggle, children }: Props) {
  return (
    <div className={cn("faq-item", open && "open")}>
      <button
        type="button"
        className="faq-question"
        aria-expanded={open}
        onClick={onToggle}
      >
        <span>{question}</span>
        <svg
          className="faq-chevron"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
      <div className="faq-answer">
        <div className="faq-answer-inner">{children}</div>
      </div>
    </div>
  );
}
